export const DeliverableSocialPlatform = {
    INSTAGRAM: 'Instagram',
    FACEBOOK: 'Facebook',
    TIKTOK: 'TikTok',
    TWITTER: 'Twitter',
    YOUTUBE: 'YouTube',
    PINTEREST: 'Pinterest',
    SNAPCHAT: 'Snapchat',
    OTHER: 'Other'
};



// WEBPACK FOOTER //
// ./common/language/content_component/deliverable_social_platform.js